import { HttpRequest, HttpResponse } from '@angular/common/http';

export abstract class SsrCookieReconciliationService {
  abstract reconcileRequest(httpReq: HttpRequest<unknown>): HttpRequest<unknown>;
  abstract reconcileResponse(httpRes: HttpResponse<unknown>): void;
}
